import React, { useState } from "react";
import { GridLayout, HorizontalLayout, VerticalLayout } from "../components/layout";
import { icon } from "../functions/icons";
import { StandardButton } from "../atoms/buttons";
import { LayoutButton } from "../atoms/presentation";
import { InputFile } from "../atoms/input";

export function DocumentsPanel({ previewedDocId, documents, selectedDocIds, setSelectedDocIds, onFileUpload, style, selectPDF }) {
  const [viewOptions, setViewOptions] = useState(1);
  const isGrid = viewOptions === 2;

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      onFileUpload(file);
      e.target.value = "";
    }
  }

    function toggleDocumentSelection(id_document) {
      console.log("Toggling document selection for:", id_document);
      setSelectedDocIds(prev => {
        if (prev.includes(id_document)) {
          return prev.filter(i => i !== id_document);
        } else {
          return [...prev, id_document];
        }
      });
    }
  console.log("documents:", documents);
  return (
    <VerticalLayout style={{ ...style }}>
      <HorizontalLayout className="desc-documents space-between standard-margin-bottom" style={{ gap: ".5rem" }}>
        <p className="small-text-light">
          Hier vind je jouw documenten. Kies er één of meerdere om te gebruiken of upload een nieuw document.
        </p>
        <LayoutButton
          listViewFunction={() => setViewOptions(1)}
          gridViewFunction={() => setViewOptions(2)}
          currentPresentation={viewOptions}
        />
      </HorizontalLayout>

      <GridLayout
        className={isGrid ? "" : "flex"}
        style={{
          flexDirection: isGrid ? "" : "column",
          maxHeight: "257px",
          overflowY: "scroll",
          overflowX: "hidden",
          padding: "1rem",
        }}
        columnsTemplate="repeat(auto-fill, minmax(240px, 1fr))"
        gap="1rem"
      >
      {documents.map(doc => {
        const isSelected = selectedDocIds.includes(doc.id_document);
        const isPreviewed = previewedDocId === doc.id_document;

        return (
          <VerticalLayout
            key={doc.id_document}
            className={`file-card ${isSelected ? "file-card--active" : ""}`}
          >
            <div
              className="file-card__content"
              style={{ flexDirection: isGrid ? "" : "row", alignItems: "center" }}
              onClick={() => toggleDocumentSelection(doc.id_document)} // toggle multi-select
            >
              {icon("documents", 20)}
              <span style={{ maxWidth: isSelected ? "15rem" : "unset" }} className="file-card__name">
                {doc.title}
              </span>
              {isSelected && (
                <span
                  style={{ marginLeft: "auto", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation(); // prevent multi-select toggle
                    selectPDF(doc.id_document); // preview
                  }}
                >
                  {icon("eye", 20)} {/* preview icon */}
                </span>
              )}
            </div>
          </VerticalLayout>
        );
      })}
      </GridLayout>
      <InputFile
        className="center upload-btn standard-margin-top document-upload"
        title=""
        icon2=""
        verb="Upload nieuw document"
        extraVerb=""
        fileChange={handleFileChange}
        accept=".pdf"
      />
    </VerticalLayout>
  );
}
